import Raven from 'raven-js';
import { getPortalAccountId } from 'portals-platform-lib';
export const CANCEL_REQUEST_COOLDOWN_MS = 3 * 24 * 60 * 60 * 1000;
const STORAGE_KEY_PREFIX = 'revenue-billing-portal:cancel-request';
function getStorageKey(objectId) {
  return `${STORAGE_KEY_PREFIX}:${getPortalAccountId()}:${objectId}`;
}
export function getActiveCancelRequestTimestamp(objectId) {
  try {
    const key = getStorageKey(objectId);
    const stored = window.localStorage.getItem(key);
    if (!stored) {
      return null;
    }
    const requestedAt = Number(stored);
    const age = Date.now() - requestedAt;
    const isWithinCooldown = age >= 0 && age < CANCEL_REQUEST_COOLDOWN_MS;
    if (!isWithinCooldown) {
      window.localStorage.removeItem(key);
      return null;
    }
    return requestedAt;
  } catch (error) {
    Raven.captureException(error instanceof Error ? error : new Error(String(error)));
    return null;
  }
}
export function recordCancelRequest(objectId, timestamp = Date.now()) {
  try {
    window.localStorage.setItem(getStorageKey(objectId), String(timestamp));
  } catch (error) {
    Raven.captureException(error instanceof Error ? error : new Error(String(error)));
  }
}